
    <div class="modal-column">
      <form [formGroup]="form">
        <app-currency-selector formControlName="currency"></app-currency-selector>

        <div class="dw-tabs-menu">
          <button class="dw-tabs-item active">
            <span class="arrow-icon"><i class="fal fa-arrow-up"></i></span> Deposit
          </button>
          <button class="dw-tabs-item" [routerLink]="['/', { outlets: { modal: 'withdraw' } }]">
            <span class="arrow-icon"> <i class="fal fa-arrow-down"></i> </span> Withdraw
          </button>
        </div>

        <ng-container *ngIf="isFiat(currency)">
          <p *ngIf="!walletAddress">Please wait, your deposit wallet is being created.</p>
          <app-fiat-deposit *ngIf="walletAddress" [address]="walletAddress"></app-fiat-deposit>
        </ng-container>

        <ng-container *ngIf="!isFiat(currency)">
          <h5>Your {{ currency }} deposit address</h5>
          <p class="deposit-paragraph">
            This address accepts only {{ currency }}, transferring here anything else will result in fund loss.
          </p>

          <p class="deposit-paragraph" *ngIf="currency === 'ETH'">
            <strong>Notice:</strong> Make sure your gas limit is set to at least <strong>39595</strong> and not to 21000.
            Transaction will be canceled if gas limit is less than <strong>39595</strong>.
          </p>

          <div class="deposit-address-wrap">
            <div class="address" [cbContent]="walletAddress" ngxClipboard>
              {{ walletAddress ? walletAddress : 'Creating new ' + currency + ' wallet' }}
            </div>
            <div class="deposit-right-flex">
              <button class="qr-code-small" [disabled]="!walletAddress" (click)="showQr = !showQr"></button>
              <button class="copy-address" [disabled]="!walletAddress" ngxClipboard [cbContent]="walletAddress">
                <i class="fal fa-copy"></i>
              </button>
            </div>
          </div>

          <div class="deposit-limits">
            Minimum deposit amount is <span class="deposit-limit-feature">{{ minAmount | crypto: currency }}</span
            >. Maximum deposit is <span class="deposit-limit-feature">{{ maxAmount | crypto: currency }}</span
            >.
          </div>
          <div class="deposit-limits">
            If your deposit amount will be lower than
            <span class="deposit-limit-feature">{{ minAmount | crypto: currency }}</span
            >, <span class="deposit-limit-feature">{{ feeAmount | crypto: currency }}</span> will be deducted from your
            balance.
          </div>

          <div class="deposit-limits" *ngIf="currency === 'ETH'">
            <strong>Warning:</strong> Do not deposit from smart contract address, deposit from your wallet, otherwise
            you will lose your coins/money.
          </div>

          <app-deposit-bonus-notice></app-deposit-bonus-notice>

          <div class="qr-code-big-wrap" *ngIf="showQr">
            <div class="qr-code-big">
              <ng-container *ngIf="appUrl">
                <a [href]="appUrl" rel="nofollow noopener noreferral">
                  <img [src]="qrLargeUrl" [alt]="walletAddress" />
                </a>
              </ng-container>
              <ng-container *ngIf="!appUrl"> <img [src]="qrLargeUrl" [alt]="walletAddress" /> </ng-container>
            </div>
          </div>
        </ng-container>
      </form>
    </div>

    <a
      [routerLink]="['/', { outlets: { modal: null } }]"
      class="icon close-popup"
      (click)="trackDepositClose()"
      data-id="deposit-close-href"
    >
      <i class="fal fa-times"></i>
    </a>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/deposit/deposit-modal-2.component.ts.DepositModal2Component.html